module.exports = __webpack_public_path__ + "img/y-46.f72744c8.png";